module.exports = __webpack_public_path__ + "img/cooperation_process4.f5c43b49.png";